<!-- 缓考申请 -->
<template>
  <div class="application-postponement">
    <div class="title">
      <h2 class="fl">{{ $route.meta.title }}</h2>
      <button class="fr upload-btn" @click="openDio">
        下载模板上传
      </button>
    </div>
    <div class="app-main">
      <div class="main-title">
        <span>名称</span>
        <span>上传时间</span>
        <span>下载</span>
      </div>
      <div class="main-conent" v-for="(item, index) in dataList" :key="index">
        <span>{{ item.name }}</span>
        <span>{{ item.create_time | dateFormat }}</span>
        <span class="look" @click="openNew(item.file)">文件查看</span>
      </div>
    </div>

    <el-dialog
      title="上传"
      :visible.sync="centerDialogVisible"
      width="920px"
      center
      class="dialog3"
    >
      <div class="concent1">
        <div class="main1">
          <span class="title1">模板文件下载:</span>
          <span class="text1" @click="openNew($route.meta.file)">模板文件</span>
          <button class="btn1" @click="openNew($route.meta.file)">下载</button>
        </div>
        <div class="main2">
          <div class="input-box">
            <input
              type="text"
              v-model="file"
              class="input1"
              placeholder="请选择已经填好的模板文件"
            />
            <button class="input-btn" @click.stop="uploadHeadImg">
              选择文件
            </button>

            <input
              type="file"
              ref="upload"
              @change="handleFile($event)"
              style="display:none"
            />
          </div>
          <p class="text2">
            备注:请先下载模板文件到本地，按照要求填写完整后在选择上传
          </p>
        </div>
        <div class="main3">
          <button class="btn3" @click="onUpload">上传</button>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import encrypt from "../utils/encrypt";
import { Message } from "element-ui";
import { uploadImg, uploadFile } from "@/api/home";
import {
  getTeacherApplyTypeList,
  getTeacherApplyList,
  submitTeacherApply,
} from "@/api/common";
import { getToken, getUid } from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      centerDialogVisible: false,
      page: 1,
      total: 0,
      dataList: [],
      name: "",
      file: undefined,
    };
  },
  //监听属性 类似于data概念
  computed: {
    names() {
      return this.$route.meta.title;
    },
  },
  //监控data中的数据变化
  watch: {
    names: {
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.fetchData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  //方法集合
  methods: {
    uploadHeadImg() {
      this.$refs.upload.click();
    },
    handleFile(e) {
      let that = this;
      let file = e.target.files[0];
      let formData = new FormData();
      this.name = e.target.files[0].name;
      formData.append("file", file);
      uploadFile(formData).then((res) => {
        this.$message.success("上传成功");
        this.file = res.data;
      }).catch((error) => {
          Message({
            message: error.msg,
            type: "error",
            duration: 3 * 1000,
          });
        });
    },
    openNew(val) {
      if (val == null) {
        this.$message("文件不存在,无法进行下载");
      } else {
        window.open(val, "_blank");
      }
    },
    openDio() {
      this.centerDialogVisible = true;
      (this.name = ""), (this.file = undefined);
    },
    onUpload() {
      let token = getToken();
      let type = this.$route.meta.id;
      let file = this.file;
      let name = this.name;
      let uid = getUid();
      let data = {
        uid: uid,
        type_id: type,
        name: name,
        file: file,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      submitTeacherApply(params)
        .then((response) => {
          this.centerDialogVisible = false;
          this.fetchData();
        })
        .catch((error) => {
          Message({
            message: error.msg,
            type: "error",
            duration: 3 * 1000,
          });
        });
    },
    fetchData() {
      let token = getToken();
      let type = this.$route.meta.id;
      let uid = getUid();
      let data = {
        uid: uid,
        type: type,
        page: 1,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      getTeacherApplyList(params)
        .then((response) => {
          this.dataList = response.data;
        })
        .catch((error) => {
          Message({
            message: error.msg,
            type: "error",
            duration: 3 * 1000,
          });
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>

<style lang="scss">
.dialog3 {
  .concent1 {
    padding-top: 95px;
    padding-bottom: 80px;
    padding-left: 75px;
    height: 475px;
    .main1 {
      margin-bottom: 40px;
      .title1 {
        color: #007dbf;
        font-size: 20px;
        display: inline-block;
        margin-right: 20px;
      }
      .text1 {
        font-size: 20px;
        text-decoration: underline;
        color: #666666;
        display: inline-block;
        margin-right: 30px;
        cursor: pointer;
      }
      .btn1 {
        outline: none;
        border: none;
        cursor: pointer;
        background-color: #017dc3;
        color: #ffffff;
        width: 90px;
        height: 40px;
        font-size: 16px;
      }
    }
    .main2 {
      max-width: 775px;
      margin-bottom: 45px;
      .input-box {
        margin-bottom: 35px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .input1 {
          width: 68%;
          padding-left: 30px;
          display: inline-block;
          outline: none;
          border: none;
          height: 63px;
          color: #676767;
          background-color: #e7e7e7;
        }
        .input-btn {
          outline: none;
          border: none;
          cursor: pointer;
          background-color: #017dc3;
          color: #ffffff;
          width: 220px;
          height: 65px;
          font-size: 16px;
        }
      }
      .text2 {
        font-size: 17px;
        color: #fe0002;
      }
    }
    .main3 {
      .btn3 {
        outline: none;
        border: none;
        cursor: pointer;
        background-color: #017dc3;
        color: #ffffff;
        width: 220px;
        height: 65px;
        font-size: 18px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.application-postponement {
  min-width: 665px;
}
.title {
  padding-left: 37px;
  padding-right: 60px;
  height: 75px;
  line-height: 75px;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  align-content: center;
  justify-content: space-between;
  h2 {
    font-size: 24px;
    color: #00468e;
    @media screen and (max-width: 1010px) {
      font-size: 20px;
    }
  }

  .upload-btn {
    background-color: #007dc2;
    outline: none;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    width: 185px;
    height: 44px;
    font-size: 16px;
    margin: auto 0;
    cursor: pointer;
    @media screen and (max-width: 1010px) {
      width: 130px;
      font-size: 14px;
    }
  }
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.app-main {
  height: calc(100% - 75px);
  padding-top: 37px;
  padding-left: 37px;
  padding-right: 60px;
  .main-title {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    grid-template-rows: 27px;
    font-size: 15px;
    color: #000000;
    border-bottom: 1px solid #d7d7d7;
    span {
      padding-left: 9px;
    }
  }
  .main-conent {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    grid-template-rows: 48px;
    line-height: 48px;
    font-size: 15px;
    color: #999999;
    border-bottom: 1px solid #d7d7d7;
    span {
      padding-left: 9px;
    }
    .look {
      color: #007dc2;
      cursor: pointer;
    }
  }
}
</style>
